<template>
  <PieChart :width="width" :height="height" :chart-data="data" :options="options" />
</template>

<script>
import PieChart from '@/components/chart/PieChart';

export default {
  props: {
    list: {
      type: Object,
      default() {
        return {
          labels: [],
          data: [],
        };
      },
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
  },

  components: {
    PieChart,
  },

  computed: {
    data() {
      const { labels, data } = this.list;
      return {
        labels,
        datasets: [
          {
            data,
            backgroundColor: ['#91c714', '#285FD3', '#FFC533', '#FF8B26', '#d32929'],
            hoverBackgroundColor: ['#91c714', '#285FD3', '#FFC533', '#FF8B26', '#d32929'],
            borderWidth: 5,
            borderColor: this.$store.getters.darkMode ? '#303953' : '#fff',
          },
        ],
      };
    },
    options() {
      return {
        legend: {
          display: false,
        },
      };
    },
  },
};
</script>
